export const industries = [
  {
    id: 'dairy',
    slug: 'dairy',
    icon: 'milk',
    title: {
      el: 'Γαλακτοκομικά',
      en: 'Dairy'
    },
    description: {
      el: 'Ολοκληρωμένες λύσεις για γάλα, γιαούρτι, τυρί, βούτυρο και παγωτό',
      en: 'Complete solutions for milk, yoghurt, cheese, butter and ice cream'
    },
    subcategories: [
      { id: 'milk', slug: 'milk', title: { el: 'Γάλα', en: 'Milk' } },
      { id: 'yoghurt', slug: 'yoghurt', title: { el: 'Γιαούρτι', en: 'Yoghurt' } },
      { id: 'cheese', slug: 'cheese', title: { el: 'Τυρί', en: 'Cheese' } },
      { id: 'butter', slug: 'butter', title: { el: 'Βούτυρο', en: 'Butter' } },
      { id: 'ice-cream', slug: 'ice-cream', title: { el: 'Παγωτό', en: 'Ice Cream' } }
    ]
  },
  {
    id: 'beverage',
    slug: 'beverage',
    icon: 'glass-bottle',
    title: {
      el: 'Ποτά',
      en: 'Beverages'
    },
    description: {
      el: 'Λύσεις για νερό, χυμούς, αναψυκτικά, μπύρα και οίνο',
      en: 'Solutions for water, juices, soft drinks, beer and wine'
    },
    subcategories: [
      { id: 'water', slug: 'water', title: { el: 'Νερό', en: 'Water' } },
      { id: 'soft-drinks', slug: 'soft-drinks', title: { el: 'Αναψυκτικά', en: 'Soft Drinks' } },
      { id: 'juices', slug: 'juices', title: { el: 'Χυμοί', en: 'Juices' } },
      { id: 'beer', slug: 'beer', title: { el: 'Μπύρα', en: 'Beer' } },
      { id: 'wine', slug: 'wine', title: { el: 'Οίνος', en: 'Wine' } }
    ]
  },
  {
    id: 'bakery',
    slug: 'bakery-grains-snacks',
    icon: 'croissant',
    title: {
      el: 'Αρτοσκευάσματα, Δημητριακά & Σνακ',
      en: 'Bakery, Grains & Snacks'
    },
    description: {
      el: 'Εξοπλισμός για αρτοσκευάσματα, δημητριακά και σνακ',
      en: 'Equipment for bakery products, grains and snacks'
    },
    subcategories: []
  },
  {
    id: 'meat-fish-eggs',
    slug: 'meat-fish-eggs',
    icon: 'beef',
    title: {
      el: 'Κρέας, Ψάρι & Αυγά',
      en: 'Meat, Fish & Eggs'
    },
    description: {
      el: 'Λύσεις συσκευασίας και ποιοτικού ελέγχου για κρέας, ψάρι και αυγά',
      en: 'Packaging and quality control solutions for meat, fish and eggs'
    },
    subcategories: [
      { id: 'meat-fish', slug: 'meat-fish', title: { el: 'Κρέας & Ψάρι', en: 'Meat & Fish' } },
      { id: 'eggs', slug: 'eggs', title: { el: 'Αυγά', en: 'Eggs' } }
    ]
  },
  {
    id: 'oils-fats',
    slug: 'oils-fats',
    icon: 'droplet',
    title: {
      el: 'Έλαια & Λίπη',
      en: 'Oils & Fats'
    },
    description: {
      el: 'Εξειδικευμένες λύσεις για φυτικά έλαια, μαργαρίνες και λίπη',
      en: 'Specialized solutions for vegetable oils, margarines and fats'
    },
    subcategories: [
      { id: 'oils', slug: 'oils', title: { el: 'Έλαια', en: 'Oils' } },
      { id: 'fats', slug: 'fats', title: { el: 'Λίπη', en: 'Fats' } }
    ]
  },
  {
    id: 'spreads-sauces',
    slug: 'spreads-sauces',
    icon: 'spreads-bowl',
    title: {
      el: 'Αλείμματα & Σάλτσες',
      en: 'Spreads & Sauces'
    },
    description: {
      el: 'Ολοκληρωμένες λύσεις για αλείμματα και σάλτσες',
      en: 'Complete solutions for spreads and sauces'
    },
    subcategories: []
  },
  {
    id: 'fruit-vegetables',
    slug: 'fruit-vegetables',
    icon: 'apple',
    title: {
      el: 'Φρούτα & Λαχανικά',
      en: 'Fruit & Vegetables'
    },
    description: {
      el: 'Λύσεις για συσκευασία φρούτων και λαχανικών',
      en: 'Solutions for fruit and vegetable packaging'
    },
    subcategories: []
  },
  {
    id: 'ready-meals',
    slug: 'ready-meals',
    icon: 'utensils',
    title: {
      el: 'Έτοιμα Γεύματα',
      en: 'Ready Meals'
    },
    description: {
      el: 'Λύσεις για παραγωγή και συσκευασία έτοιμων γευμάτων',
      en: 'Solutions for ready meal production and packaging'
    },
    subcategories: []
  }
];